import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-s-pager',
  templateUrl: './s-pager.component.html',
  styleUrls: ['./s-pager.component.less']
})
export class SPagerComponent implements OnInit, AfterViewInit {
  @Input() pageData;
  @Output() pageIndex: EventEmitter<any> = new EventEmitter();
  @Output() pageSize: EventEmitter<any> = new EventEmitter();
  constructor() { }
  ngAfterViewInit(): void {
    const pageHeight = document.getElementsByTagName('nz-pagination')[0].clientHeight;
    sessionStorage.setItem('pageHeight', JSON.stringify(pageHeight));
  }

  ngOnInit(): void {
  }

  pageIndexChange(e) {
    this.pageData.page = e;
    this.pageIndex.emit(e);
  }
  pageSizeChange(e) {
    this.pageData.pageSize = e;
    this.pageSize.emit(e);
  }

}
